import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { Component } from "react";
import { selectedAutomationNode } from "../../Template/NewTemplateSignals";
import { EventMap } from "../NodeEvents";

export class EventProperty extends Component {
  constructor({ value, handlePropertyChange }) {
    super();
    this.state = {
      value: value,
    };
    this.handlePropertyChange = handlePropertyChange;
  }

  render() {
    return (
      <div
        key={`${selectedAutomationNode.value.options.id}`}
        className="k-my-2 k-mx-2"
      >
        <Label style={{ fontSize: "14px", fontWeight: "600" }}>Event:</Label>
        <DropDownList
          data={EventMap.map((item) => item.Name)}
          defaultValue={this.state.value}
          onChange={(e) => {
            this.handlePropertyChange({
              e: { ...e, target: { ...e.target, value: e.value } },
              propertyName: "Event",
            });
          }}
        />
      </div>
    );
  }
}
